import React from 'react';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12 border-t border-slate-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
            <div className="col-span-1 md:col-span-2">
                <h4 className="font-serif text-xl font-bold text-white mb-4">Digital Assets Literacy</h4>
                <p className="text-sm max-w-xs mb-4">
                    Professional education for the modern financial advisor. Building trust through knowledge and compliance.
                </p>
            </div>
            <div>
                <h5 className="font-semibold text-white mb-3">Links</h5>
                <ul className="space-y-2 text-sm">
                    <li><a href="#" className="hover:text-white transition-colors">Curriculum</a></li>
                    <li><a href="#" className="hover:text-white transition-colors">Login</a></li>
                </ul>
            </div>
            <div>
                <h5 className="font-semibold text-white mb-3">Legal</h5>
                <ul className="space-y-2 text-sm">
                    <li><a href="#" className="hover:text-white transition-colors">Privacy Policy</a></li>
                    <li><a href="#" className="hover:text-white transition-colors">Terms of Service</a></li>
                </ul>
            </div>
        </div>
        
        <div className="pt-8 border-t border-slate-800">
            <h5 className="text-xs font-bold uppercase tracking-wider text-slate-500 mb-2">Educational Use Only</h5>
            <p className="text-xs text-slate-500 leading-relaxed max-w-4xl">
                This course is for informational and educational purposes and does not provide investment, tax, or legal advice. Participants should follow all firm policies and applicable regulatory requirements when engaging with clients. The information presented does not constitute a recommendation to buy or sell any financial instrument.
            </p>
            <div className="mt-8 text-center text-slate-600 text-sm">
                © {new Date().getFullYear()} Digital Assets Literacy. All rights reserved.
            </div>
        </div>
      </div>
    </footer>
  );
};